import { DirectTask } from '@frame/lib/api/tasks/types'

export function getTaskId(task?: DirectTask): string {
  if (task?.id) {
    return task.id
  }
  throw Error('Direct task does not have an id!')
}
